/**
 * Application Constants
 * Contains various constant values used throughout the application
*/

// Visualization and View Type Constants
export const Constants = {
    "Map": "map",           // Map visualization type
    "Line": "line",         // Line chart visualization type
    "Bar": "bar",           // Bar chart visualization type
    "District": "district", // District-level view
    "State": "state",       // State-level view
    "Total": "all",       // Combined data view
    "Urban": "urban",       // Urban area filter
    "Rural": "rural",       // Rural area filter
}

// Column Keys for State View Data
export const StateViewKeys = {
    "stc": "State Code",         // State identifier code
    "stc_name": "State Name",    // Full state name
    "sector": "Sector",          // Economic/social sector
    "unit": "Unit",              // Measurement unit
}

// Column Keys for District View Data
export const DistrictViewKeys = {
    "dtc": "District Code",           // District identifier code
    "dtc_name": "District Name",      // Full district name
    "stc_dtc_name": "State Name",     // Parent state name
    "sector": "Sector",               // Economic/social sector
    "unit": "Unit",                   // Measurement unit
}

// Full Forms of Data Source Abbreviations
export const FullForms = {
    "CENSUS": "census in 2011",
    "NFHS": "National Family Health Survey",
    "NSS": "National Sample Survey Office",
    "PLFS": "Periodic Labour Force Survey",
    // "SRS": "Sample Registration System",  // Currently unused
    "ASI": "Annual Survey of Industries",
    "NCRB": "National Crime Records Beaureau",
    "RBI": "Reserve Bank of India",
    "CAMS": "Comprehensive Annual Modular Survey"
}